module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/temperature-empty-86e79602dfabd5cd7a868603bdcf61bb.svg";